import './css/staff-modal.css';

import React from 'react';
import Form from './Form';
import Protected from './Protected';
import ContactGroupEditor from './ContactGroupEditor';
import DatePicker from 'react-datepicker';

import { Data } from 'service/util';

import SearchableList from './dropdown/SearchableList';

function K(loc)
{
  return `${loc.srv_dis}${loc.srv_loc}`;
}

class StaffModal extends React.Component
{
  constructor(props)
  {
    super(props);

    // deep copy
    let locations = JSON.parse(JSON.stringify(Data.location));
    let mapLoc = locations.reduce((map,x) => {
      map.set( K(x), x );
      return map;
    }, new Map());
    let selwl = props.context.staff.locations.reduce((r,x) => {
      let k = K(x);
      Object.assign( mapLoc.get(k), x);
      r[k] = x;
      return r;
    }, {});

    this.state = {
      locations, // deep copy
      selwl,
      password: '',
      page: 1,
      filter_district: props.context.staff.locations[0]?.srv_dis||Data.district[0].cd,
      filter_selectedOnly: false,
    };

    this.confirmChange = this.confirmChange.bind(this);
    this.setv = this.setv.bind(this);
    this.setStaff = this.setStaff.bind(this);

  }

  confirmChange(e)
  {
    let loc = this.props.context.staff.locations;
    loc.splice(0, loc.length);
    Object.values(this.state.selwl).forEach(x => loc.push(x));
    return this.props.submitModal(e, this.state.password);
  }

  setv(key, value) {
    let context = {...this.props.context};
    context.staff[key] = value;
    this.forceUpdate();
  }

  setStaff(staff) {
    this.setv('supervisor', staff.id);
    this.setv('supervisor_name', staff.id ? staff.display_name : '');
  }

  render()
  {
    let m = this.props.context;
    return (
      <div className="modal" id="modal-staff">
        <div className="modal-box">
          {
            m.mode==='add'
            ?<h2 className="modal-head">新增</h2>
            :<h2 className="modal-head">編輯 - ({m.staff.id}) {m.staff.display_name}</h2>
          }
          <Form className="modal-body" onSubmit={this.confirmChange}>
            {
              m.staff.role!=='WORKER'
              ?this.renderInfoEdit(m)
              :<>
                <div className="tab-panel">
                  <span className={`tab-button` + (this.state.page===1?' selected':'')} onClick={e=>this.setState({page:1})}>員工資料</span>
                  <span className={`tab-button` + (this.state.page===2?' selected':'')} onClick={e=>this.setState({page:2})}>負責屋苑</span>
                </div>
                <div className="tab-frame">
                  { this.renderTabBody(m) }
                </div>
              </>
            }
            <div className="action-panel">
              <button className="btn grey" type="button"
                      onClick={e=>this.props.closeModal()}>關閉</button>
              <button id="btn-submit" className="btn blue" >確定</button>
            </div>
            {
              !m.error?'':<div className="error-msg">{ m.error }</div>
            }
          </Form>
        </div>
      </div>
    );
  } // render()

  renderTabBody(context)
  {
    switch (this.state.page)
    {
      case 1: return this.renderInfoEdit(context);
      case 2: return this.renderLocEdit(context);
    }
  }

  renderInfoEdit(m)
  {
    const isEmployeeAccount = -1<['OPERATOR', 'VIEWER', 'WORKER'].indexOf(m.staff.role);

    let supervisor = this.props.employees?.filter(
      emp => emp.id == m.staff.supervisor
    )[0];

    return (<>
      <Protected when={m.mode!=='add'}>
        <label className="field">
          <strong>使用者角色</strong>
          <select value={ m.staff.role }
                  onChange={ e=>this.setv('role', e.target.value )}>
            <Protected>
              <option value="SYSTEM">System Account</option>
              <option value="ADMIN">Administrator</option>
            </Protected>
            <Protected allow={['ADMIN']}>
              <option value="VIEWER_SU">Super Viewer</option>
            </Protected>
            <option value="WORKER">工人 (Worker)</option>
            <option value="VIEWER_DAY">日班 (Day Viewer)</option>
            <option value="VIEWER_NIGHT">夜班 (Night Viewer)</option>
            <option value="OPERATOR">操作員 (Operator)</option>
          </select>
        </label>
      </Protected>
      {
        m.staff.role!='WORKER'?''
        :<label className="field">
          <strong>工人篇號</strong>
          <input type="text" value={m.staff.worker_code||''}
                onChange={ e=>this.setv('worker_code', e.target.value.trim() ) }/>
        </label>
      }
      { (m.mode!='edit' || isEmployeeAccount) && <>
        <label className="field">
          <strong>身份證</strong>
          <input value={m.staff.hkid} onChange={ e=>this.setv('hkid', e.target.value.toUpperCase()) } />
        </label>
        <label className="field">
          <strong>主管</strong>
          <SearchableList value={supervisor} onChange={ this.setStaff }
            items={this.props.employees}
            filter={(e,v) => -1<`${e.id}||${e.display_name}`.toUpperCase().indexOf(v.toUpperCase())}
            getTitle={emp => emp.id}
            getDesc={emp => emp.display_name}
            withDefault={{id: null, display_name: "(無)"}}
          />
        </label>
        <label className="field">
          <strong>入職日期</strong>
          <DatePicker selected={m.staff.employ_dtm} onChange={ d=>this.setv('employ_dtm', d) } dateFormat="yyyy-MM-dd"/>
        </label>
      </>}
      { m.mode=='edit' && isEmployeeAccount &&
        <label className="field">
          <strong>離職日期</strong>
          <DatePicker selected={m.staff.resign_dtm} onChange={ d=>this.setv('resign_dtm', d) } dateFormat="yyyy-MM-dd"/>
        </label>
      }
      {
        (m.staff.role=='WORKER' && m.mode=='edit') &&
        <>
          <label className="field">
            <strong>奬金A</strong>
            <input type="number" value={m.staff.bonus_A} onChange={ e=>this.setv('bonus_A', parseInt(e.target.value)) } />
          </label>
          <label className="field">
            <strong>奬金B</strong>
            <input type="number" value={m.staff.bonus_B} onChange={ e=>this.setv('bonus_B', parseInt(e.target.value)) } />
          </label>
          <label className="field">
            <strong>奬金C</strong>
            <input type="number" value={m.staff.bonus_C} onChange={ e=>this.setv('bonus_C', parseInt(e.target.value)) } />
          </label>
          <label className="field">
            <strong>額外奬金</strong>
            <input type="number" value={m.staff.bonus_extra} onChange={ e=>this.setv('bonus_extra', parseInt(e.target.value)) } />
          </label>
          <label className="field">
            <strong>薪金津貼</strong>
            <input type="number" value={m.staff.allowance} onChange={ e=>this.setv('allowance', parseInt(e.target.value)) } />
          </label>
        </>
      }
      <label className="field">
        <strong>顯示名稱</strong>
        <input type="text" value={m.staff.display_name} required
               onChange={ e=>this.setv('display_name', e.target.value.trimStart() ) }/>
      </label>
      {
        m.mode!=='add'?'':
        <label className="field">
          <strong>登入名稱</strong>
          <input type="text" pattern="[a-z0-9]{3,}" placeholder="三個以上英數字元"
                 value={m.staff.username}
                 onChange={ e=>this.setv('username', e.target.value.trimStart().toLowerCase() ) }/>
        </label>
      }
      <Protected when={m.staff.role!=='SYSTEM'}>
        <label className="field">
          <strong>密碼</strong>
          {
            'add'===m.mode
            ?<input type="password" value={this.state.password} autocomplete="off"
                    pattern=".{6,}" placeholder="為新使用者建立登入密碼"
                    onChange={ e=>this.setState({password: e.target.value.trimStart()}) }/>
            :<input type="password" value={this.state.password} autocomplete="off"
                    pattern=".{6,}" placeholder="重新設定密碼，如無需更改請留白。"
                    onChange={ e=>this.setState({password: e.target.value.trimStart()}) }/>
          }
        </label>
      </Protected>
      { (m.mode!='edit' || isEmployeeAccount) &&
        <label className="field">
          <strong>聯絡方式</strong>
          <ContactGroupEditor contacts={m.staff.contacts} />
        </label>
      }
      { (m.mode=='edit') &&
        <Protected allow={['ADMIN']}>
          <label className="field">
            <strong>狀態</strong>
            <input type="checkbox" checked={m.staff.active} onChange={ e=>this.setv('active', e.target.checked) }/>
          </label>
        </Protected>
      }
    </>);
  } // render tab edit staff info

  toggleWorkerLocation(loc, val)
  {
    let key = K(loc), selwl = this.state.selwl;
    if (val) {
      selwl[key] = loc;
    }
    else delete selwl[key];
    this.forceUpdate();
  }
  setFloor(loc, floor)
  {
    loc.srv_floor = floor;
    this.forceUpdate();
  }

  renderLocEdit(m)
  {
    let locs;
    let selwl = this.state.selwl; // selected worker location
    if (this.state.filter_selectedOnly) {
      locs = Object.values(selwl);
      locs.sort((a,b) => {
        if (a.srv_dis > b.srv_dis) return  1;
        if (a.srv_dis < b.srv_dis) return -1;
        if (a.srv_loc > b.srv_loc) return  1;
        if (a.srv_loc < b.srv_loc) return -1;
        return 0;
      });
    } else {
      locs = this.state.locations;
      if (this.state.filter_district) {
        locs = locs.filter(x => x.srv_dis === this.state.filter_district);
      }
    }

    return (
      <div className="work-loc-edit-frame">
        <div className="search-bar">
          <div className="split-3">
            <label className="field-row">
              <strong>僅顯示已選取</strong>
              <input type="checkbox" checked={this.state.filter_selectedOnly}
                     onChange={e=>this.setState({filter_selectedOnly: e.target.checked})} />
            </label>
            <label className="field-row">
              <strong>地區</strong>
              <select value={this.state.filter_district}
                      onChange={e=>this.setState({filter_district: e.target.value})}>
                <option value="">全部</option>
                { Data.district.map(d =>
                  <option key={`dis-${d.cd}`} value={d.cd}>{d.cd} - {d.name}</option>
                )}
              </select>
            </label>
          </div>
        </div>
        <table className="data-table full-width">
          <colgroup>
            <col width="36px"  id="wl-sel" />
            <col width="60px"  id="wl-loc" />
            <col width="auto"  id="wl-name" />
            <col width="200px" id="wl-floor" />
          </colgroup>
          <thead>
            <th className="wl-sel"></th>
            <th className="wl-loc">#</th>
            <th className="wl-name">屋苑名稱</th>
            <th className="wl-floor">負責樓層</th>
          </thead>
          <tbody>
            {locs.map(l =>
              <label key={`loc-${K(l)}`} className="table-row">
                <div className="wl-sel">
                  <input type="checkbox" checked={K(l) in selwl}
                        onChange={e=>this.toggleWorkerLocation(l, e.target.checked)}/>
                </div>
                <div className="wl-loc">
                  { K(l) }
                </div>
                <div className="wl-name">
                  { `${l.name_zh} ${l.name_en}`.trim() }
                </div>
                <div className="wl-floor">
                  <input type="text" value={l.srv_floor||''}
                        onChange={e=>this.setFloor(l, e.target.value)}/>
                </div>
              </label>
            )}
          </tbody>
        </table>
      </div>
    );
  } // render tab worker's service location list


}

export default StaffModal;